/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NendCampaignEditForm_nendCampaign = {
    readonly id: string;
    readonly title: string;
    readonly nendCampaignId: string | null;
    readonly createdAt: string;
    readonly " $refType": "NendCampaignEditForm_nendCampaign";
};
export type NendCampaignEditForm_nendCampaign$data = NendCampaignEditForm_nendCampaign;
export type NendCampaignEditForm_nendCampaign$key = {
    readonly " $data"?: NendCampaignEditForm_nendCampaign$data;
    readonly " $fragmentRefs": FragmentRefs<"NendCampaignEditForm_nendCampaign">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "NendCampaignEditForm_nendCampaign",
  "type": "NendCampaign",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "nendCampaignId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "createdAt",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'e006a81aa70caf80cd8939c2b94e1056';
export default node;
